import AddPerson from "@/assets/icons/AddPerson";
import ArrowRightIcon from "@/assets/icons/ArrowRight";
import Car from "@/assets/icons/Car";
import FlexPass from "@/assets/icons/FlexPass";
import HelpLine from "@/assets/icons/HelpLine";
import LockIcon from "@/assets/icons/Lock";
import LogOutIcon from "@/assets/icons/LogOut";
import Person from "@/assets/icons/Person";
import PurchaseHistory from "@/assets/icons/PurchaseHistory";
import DrawerItem from "@/components/layout/DrawerItem";
import LanguagePicker from "@/components/shared/LanguagePicker";
import { Box } from "@/components/ui/box";
import { Divider } from "@/components/ui/divider";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { useAuth } from "@/contexts/AuthContext";
import { DrawerActions } from "@react-navigation/native";
import { useQueryClient } from "@tanstack/react-query";
import { T, useT } from "@transifex/react";
import { useNavigation, useRouter } from "expo-router";
import type { ReactElement } from "react";
import { Pressable } from "react-native";

function DrawerContent(): ReactElement {
  const router = useRouter();
  const { user, signOut } = useAuth();
  const queryClient = useQueryClient();
  const navigation = useNavigation();
  const t = useT();

  const isVisible = !!user;

  const handleSignOut = async () => {
    try {
      await signOut();
      queryClient.clear();
      navigation.dispatch(DrawerActions.closeDrawer());
      router.replace("/welcome");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <VStack className="flex-1 bg-background-50 gap-[24px] pb-[32px] px-[20px] pt-[20px] rounded-none">
      <HStack className="gap-[20px] items-center">
        <Pressable onPress={() => navigation.dispatch(DrawerActions.closeDrawer())}>
          <ArrowRightIcon />
        </Pressable>
        <Text className="font-[700] leading-[24.2px] text-[20px] text-typography-900">
          {user ? <T _str="Hi, {user}!" user={user?.first} /> : <T _str="Welcome" />}
        </Text>
      </HStack>

      <Divider className="text-outline-300" />

      <DrawerItem
        icon={LockIcon}
        label={t("Sign In")}
        onPress={() => {
          router.push("/auth/sign-in");
        }}
        visible={!isVisible}
      />
      <DrawerItem icon={AddPerson} label={t("Create Account")} onPress={() => router.push("/auth/sign-up")} visible={!isVisible} />
      <DrawerItem icon={FlexPass} label={t("FlexPark")} onPress={() => router.push("/my-passes")} visible={isVisible} />
      <DrawerItem icon={Car} label={t("Vehicles")} onPress={() => router.push("/my-vehicles")} visible={isVisible} />
      {/* Temp hiding account history until */}
      <DrawerItem icon={PurchaseHistory} label={t("Account History")} onPress={() => router.push("/purchase/history")} visible={false} />
      <DrawerItem icon={Person} label={t("Profile")} onPress={() => router.replace("/profile")} visible={isVisible} />

      <Divider className="text-outline-300" />

      <DrawerItem icon={LogOutIcon} label={t("Sign Out")} onPress={handleSignOut} visible={isVisible} />
      <DrawerItem icon={HelpLine} label={t("Help")} onPress={() => router.push("/help")} />

      <Box className="flex-1" />
      <LanguagePicker />
    </VStack>
  );
}

export default DrawerContent;
